$(document).ready(function () {

    Handlebars.registerHelper('serialize', function (context) {
        return (context);
    });

    Handlebars.registerHelper('json', function (context) {
        return JSON.stringify(context);
    });

    Handlebars.registerHelper('equals', function (arg1, arg2, context) {
        if (arg1 == arg2) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    Handlebars.registerHelper('notEquals', function (arg1, arg2, context) {
        if (arg1 != arg2) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    Handlebars.registerHelper('string_IsNullOrEmpty', function (text) {

        return text === undefined
            || text === null
            || typeof text !== 'string'
            || typeof text.trim !== 'function'
            || text.trim() === '';

    });

    Handlebars.registerHelper('formatNumber', function (number, format, context) {
        //regex for rounding decimal ex. #.#0
        //handlebars ex. {{formatNumber PriceN '#.#0'}}
        var regex = /#\.#{0,4}[0-9]+/i;
        
        if (regex.test(format) && !isNaN(number)) {
            var decimal, place;

            decimal = format.split('.')[1];
            place = decimal.indexOf('0');
            number = number.toFixed(place + 1);

            if (LhApp.Context.Currency.DecimalSeparator === ',')
                number = number.replace('.', ',');

            return number;
        }
    });

});